export default __webpack_public_path__ + "static/media/close_popup.a6a53780.svg";